import { render, staticRenderFns } from "./question-tips.vue?vue&type=template&id=35148fbe&scoped=true&"
import script from "./question-tips.vue?vue&type=script&lang=js&"
export * from "./question-tips.vue?vue&type=script&lang=js&"
import style0 from "./question-tips.vue?vue&type=style&index=0&id=35148fbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35148fbe",
  null
  
)

export default component.exports